import React from "react";
import clsx from "clsx";

import { IClass, ITeacher } from "../../../state";
import person from "../../../assets/icon/person.svg";
import Avatar from "../../../molecules/Avatar";

import style from "./TeacherList.module.scss";

export interface ITeacherListDispatchProps {
  calling: boolean;
  dlpLogin: (id: number) => void;
  gearLogin?: (id: number) => void;
  toBuildTeacher: (id: number) => void;
  toBuildNewTeacher: () => void;
  toBulkRegisterTeachers: () => void;
}

export interface ITeacherListStateProps {
  teachers: ITeacher[];
  classes: IClass[];
}

export interface ITeacherListProps
  extends ITeacherListDispatchProps,
    ITeacherListStateProps {
  title: string;
}

export const TeacherList = (props: ITeacherListProps) => {
  return (
    <div className={style.list}>
      <div className={style.title}>
        <h3>{props.title}</h3>
        <span>ENAGEED教材を使う先生のご登録、編集が可能です。</span>
      </div>
      <div className={style.btnArea}>
        <button
          className="btn btn-outline-primary me-3"
          onClick={e => {
            e.preventDefault();
            props.toBuildNewTeacher();
          }}
        >
          新規先生登録
        </button>
        <button
          className="btn btn-outline-primary"
          onClick={e => {
            e.preventDefault();
            props.toBulkRegisterTeachers();
          }}
        >
          先生一括編集
        </button>
      </div>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th className="text-center">ID</th>
            <th className="text-center" style={{ width: 64 }}>
              顔写真
            </th>
            <th>名前</th>
            <th>Email</th>
            <th>担当クラス</th>
            <th />
            <th />
            {props.gearLogin && <th />}
            <th className="text-center">最終アクセス日</th>
          </tr>
        </thead>
        <tbody>
          {props.teachers.map(t => {
            return (
              <tr key={t.id}>
                <td className="text-center">
                  <span>{t.id}</span>
                </td>
                <td>
                  {t.photo ? (
                    <Avatar
                      src={t.photo.url}
                      alt={`${t.last_name}先生の顔写真`}
                      size={48}
                    />
                  ) : (
                    <Avatar
                      src={person}
                      alt={`${t.last_name}先生の顔写真は未設定`}
                      size={48}
                    />
                  )}
                </td>
                <td className="font-weight-bold">
                  <div className={style.nameArea}>
                    <div>{t.last_name + " " + t.first_name}</div>
                    <div className={style.tagsWrapper}>
                      {t.is_user_manager && (
                        <p className={style.manager}>学校管理者</p>
                      )}
                      {!t.serviced && <p className={style.unserviced}>無効</p>}
                    </div>
                  </div>
                </td>
                <td className="font-weight-bold">{t.email}</td>
                <td>
                  {props.classes
                    .filter(c => t.class_ids.indexOf(c.id) !== -1)
                    .map(c => (
                      <div key={`${c.id}`}>{c.full_name}</div>
                    ))}
                </td>
                <td className={clsx("text-center", style.utilBtnArea)}>
                  <button
                    className="btn btn-outline"
                    onClick={() => props.toBuildTeacher(t.id)}
                  >
                    編集
                  </button>
                </td>
                <td className={clsx("text-center", style.utilBtnArea)}>
                  <button
                    disabled={props.calling}
                    className={"btn btn-outline"}
                    onClick={() => props.dlpLogin!(t.id)}
                  >
                    教材代理ログイン
                  </button>
                </td>
                {props.gearLogin && (
                  <td className={clsx("text-center", style.utilBtnArea)}>
                    <button
                      disabled={props.calling}
                      className={"btn btn-outline"}
                      onClick={() => props.gearLogin!(t.id)}
                    >
                      GEAR代理ログイン
                    </button>
                  </td>
                )}
                <td className="text-center">{t.latest_active_date ?? "ー"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default TeacherList;
